const ThingsToDoFilters = {
    init() {
        document.querySelectorAll('[data-things-to-do]').forEach((root) => {
            const dom = this.cacheDom(root);
            if (!dom) return;

            this.bindEvents(dom);
            this.render(dom, 'all');
        });
    },

    cacheDom(root) {
        const dataEl = root.querySelector('[data-things-to-do-data]');
        const template = root.querySelector('[data-things-to-do-item-template]');
        const results = root.querySelector('.things-to-do-results');
        if (!dataEl || !template || !results) return null;

        let catalog;
        try {
            catalog = JSON.parse(dataEl.textContent);
        } catch (e) {
            return null;
        }

        return {
            root,
            results,
            template,
            filters: root.querySelectorAll('[data-filter]'),
            items: catalog.items || [],
        };
    },

    bindEvents(dom) {
        dom.filters.forEach((button) => {
            button.addEventListener('click', () => {
                this.setPressed(dom, button.dataset.filter);
                this.render(dom, button.dataset.filter);
            });
        });

        // Cards are replaced on filter, so one listener on the results
        // container covers every render. The title <a> stays the real link.
        dom.results.addEventListener('click', (event) => this.onCardClick(event));
        dom.results.addEventListener('auxclick', (event) => this.onCardClick(event));
    },

    onCardClick(event) {
        if (event.type === 'auxclick' && event.button !== 1) return;
        if (event.target.closest('a[href]')) return;

        const card = event.target.closest('.things-to-do-item');
        if (!card || !event.currentTarget.contains(card)) return;

        const link = card.querySelector('h3 a[href]');
        if (!link) return;

        const selection = window.getSelection();
        if (selection && selection.toString() && card.contains(selection.anchorNode)) return;

        const openInNewTab = event.type === 'auxclick'
            || event.metaKey
            || event.ctrlKey
            || event.shiftKey;

        if (openInNewTab) {
            event.preventDefault();
            window.open(link.href, '_blank', 'noopener,noreferrer');
            return;
        }

        link.click();
    },

    setPressed(dom, filter) {
        dom.filters.forEach((button) => {
            button.setAttribute('aria-pressed', button.dataset.filter === filter ? 'true' : 'false');
        });
    },

    render(dom, filter) {
        const items = filter === 'all'
            ? dom.items
            : dom.items.filter((item) => item.filter === filter);

        const cards = items.map((item) => this.createCard(dom.template, item));
        dom.results.replaceChildren(...cards);
    },

    createCard(template, item) {
        const card = template.content.firstElementChild.cloneNode(true);
        const type = item.type || '';

        if (type) {
            card.classList.add(`type-${type}`);
        }

        const img = card.querySelector('.things-to-do-item__image img');
        if (img) {
            if (item.image && item.image.url) {
                img.src = item.image.url;
                img.alt = item.image.alt || '';
            } else {
                img.remove();
            }
        }

        const tag = card.querySelector('.tag');
        if (tag) {
            tag.textContent = item.label || '';
        }

        const titleEl = card.querySelector('h3');
        if (titleEl) {
            const title = item.title || '';
            const url = item.link && item.link.url;

            if (url) {
                const link = document.createElement('a');
                link.href = url;
                link.innerHTML = title;
                if (item.link.is_external) {
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                }
                titleEl.appendChild(link);
            } else {
                titleEl.innerHTML = title;
            }
        }

        const description = card.querySelector('.things-to-do-item__description');
        if (description) {
            description.innerHTML = item.description || '';
        }

        return card;
    },
};

export default ThingsToDoFilters;
